import { Component, Input, OnInit } from '@angular/core';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import { FoodNode, ExampleFlatNode } from 'projects/shared/src/lib/models/ProjectTree';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { UserDto } from 'projects/shared/src/lib/models/User';

const TREE_DATA: FoodNode[] = [
  {
    name: 'Fruit',
    children: [{name: 'Apple'}, {name: 'Banana'}, {name: 'Fruit loops'}],
  },
  {
    name: 'Vegetables',
    children: [
      {
        name: 'Green',
        children: [{name: 'Broccoli'}, {name: 'Brussels sprouts'}],
      },
      {
        name: 'Orange',
        children: [{name: 'Pumpkins'}, {name: 'Carrots'}],
      },
    ],
  },
];

const PROJECTS: FoodNode[] = [
  {
    name: 'Projekt1',
    children: [{name: 'PGR11'}, {name: 'PGR12'}, {name: 'PGR13'}],
  },
  {
    name: 'Projekt2',
    children: [
      {
        name: 'PGR21',
      },
      {
        name: 'PGR22',
      },
    ],
  },
];


@Component({
  selector: 'show-user-projects',
  templateUrl: './show-user-projects.component.html',
  styleUrls: ['./show-user-projects.component.css']
})
export class ShowUserProjectsComponent implements OnInit {

  @Input('user') user!:UserDto;

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
    };
  };

  treeControl = new FlatTreeControl<ExampleFlatNode>(
    node => node.level,
    node => node.expandable,
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.children,
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  constructor(
    private tenantService:TenantService

  ) 
  {
    //this.dataSource.data = TREE_DATA;
    //this.dataSource.data = PROJECTS;

  }

  ngOnInit() {
    this.tenantService.getUserProjectsAndGrouproles(this.tenantService.currentTenantName, this.user.id).subscribe({
      next: (foodNode: FoodNode[]) => {
        this.dataSource.data = foodNode;
      },
      error: (error: any) => {
        //this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEUSERSRETRIEVEDERROR"]}`)
      }
    });

  }

}
